import { MASTER_DOMAIN, API_DOMAIN} from '@src/configs/web.config'

export default (action, data) => {
  if (window.ha && typeof window.ha === 'function') {
    window.ha('set',
      {
        siteId: 'WeLinkOpen',
        opr_wf_n: action,
      }
    )
    window.ha('setCustomData', data);
    window.ha('trackEvent', 'click');
  } else {
    let href = window.location.href;
    let ua_url, ua_f_url;
    if (href.indexOf('https://open.welink.huaweicloud') > -1) {  // 生产
      ua_url = `${API_DOMAIN}/hwa/ha.js`;
      ua_f_url = `${API_DOMAIN}/hwa/ha_f.js`;
    } else if (href.indexOf('https://open.clouduat') > -1) { //uat
      ua_url = `${API_DOMAIN}/hwa/ha.js`;
      ua_f_url = `${API_DOMAIN}/hwa/ha_f.js`;
    } else { //gamma 或者其他环境
      ua_url = `${MASTER_DOMAIN}/message/ha.js`;
      ua_f_url = `${MASTER_DOMAIN}/message/ha_f.js`;
    }

    let head = document.getElementsByTagName('head')[0];
    let scriptUa = document.createElement('script');
    scriptUa.type = 'text/javascript';
    scriptUa.onload = scriptUa.onreadystatechange = function () {
      if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
        scriptUa.onload = scriptUa.onreadystatechange = null;
        let scriptUaf = document.createElement('script');
        scriptUaf.type = 'text/javascript';
        scriptUaf.onload = scriptUaf.onreadystatechange = function () {
          if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
            window.ha('set',
              {
                siteId: 'WeLinkOpen',
                opr_wf_n: action,
              }
            )
            window.ha('setCustomData', data);
            window.ha('trackEvent', 'click');
            scriptUaf.onload = scriptUaf.onreadystatechange = null;
          }
        };
        scriptUaf.src = ua_f_url;
        head.appendChild(scriptUaf);
      }
    };
    scriptUa.src = ua_url;
    head.appendChild(scriptUa);
  }
}
